import { HtmlTemplate } from './html-template';

export class EmailTemplate extends HtmlTemplate {
  public subject: string;
  public subjectEn: string;
  public subjectEs: string;
  public subjectIt: string;
  public subjectFr: string;

  public attachTermsOfService: boolean;
}

export class OrderEmailTemplate extends EmailTemplate {
  public attachOrderSummary: boolean;
}
